import { createCommand } from '@atlassian/rovo-content-bridge-api';
import type { CommandProperties } from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link OpenRovoSidePanelCommand}
 */
export interface OpenRovoSidePanelCommandProperties extends CommandProperties {
  /**
   * Optional action ID to pre-select when opening the panel. If not provided, the panel will open with the current active action.
   */
  actionId?: string;
}

/**
 * Command to open the rovo side panel, optionally to a specific action.
 */
export const OpenRovoSidePanelCommand =
  createCommand<OpenRovoSidePanelCommandProperties>('open-rovo-side-panel');
